<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ title || ('title.preview' | translate) }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">

  </button>
</div>

<div class="modal-body">
  <div class="card">
    <iframe #previewFrame id="preview-frame" style="width: 100%; border: none; min-height: 500px;"></iframe>
  </div>
  <label *ngIf="isDeveloperUser">{{data}}</label>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-danger" (click)="exportToPdf()" [disabled]="loadingPdf">
    <i class="fa fas fa-spinner fa-spin" *ngIf="loadingPdf"></i>
    <i class="fa fas fa-file-pdf" *ngIf="!loadingPdf"></i>
    {{'button.export-to-pdf' | translate}}
  </button>
  <button type="button" class="btn btn-outline-primary" (click)="print()" [disabled]="loadingPdf">
    <i class="fa fas fa-print"></i>
    {{'button.print' | translate}}
  </button>
  <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="loadingPdf">
    {{'button.close' | translate}}
  </button>
</div>